import { render, staticRenderFns } from "./TabelaPrestadores.vue?vue&type=template&id=f1d5bdf6&scoped=true"
import script from "./TabelaPrestadores.vue?vue&type=script&lang=js"
export * from "./TabelaPrestadores.vue?vue&type=script&lang=js"
import style0 from "./TabelaPrestadores.vue?vue&type=style&index=0&id=f1d5bdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d5bdf6",
  null
  
)

export default component.exports